<!-- 对el-drawer的封装，增加底部操作栏插槽 -->
<template>
  <el-drawer v-bind="$attrs" v-on="$listeners">
    <!-- title区域 -->
    <template v-slot:title>
      <slot name="title"></slot>
    </template>
    <!-- body 区域 -->
    <template v-slot:default>
      <div class="drawer">
        <div class="drawer-body">
          <slot name="default"></slot>
        </div>
        <div class="drawer-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.drawer {
  height: 100%;
  display: flex;
  flex-direction: column;
  .drawer-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }
  .drawer-footer {
    border-top: 1px solid var(--Border-Neutral-line-dark);
    display: flex;
    flex-direction: row-reverse;
    padding: 16px;
  }
}
</style>
